/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';


export const domains = (state = defaultState.domains, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        domains = [];

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.DOMAIN_LIST:
                nextState = action.payload;
                break;

            case constants.DOMAIN_SHOW:
            case constants.DOMAIN_UPDATE:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState[i] = action.payload;
                        break;
                    }
                }
                break;

            case constants.DOMAIN_DELETE:
                for (i = 0; i < nextState.length; ++i) {
                    if (parseInt(nextState[i].id, 10) !== parseInt(action.payload.id, 10)) {
                        domains.push(nextState[i]);
                    }
                }
                nextState = domains;
                break;

            case constants.DOMAIN_CREATE:
                nextState.push(action.payload);
                break;

            case constants.DOMAIN_APPLY:
                //TODO: see if there's something to do here
                break;
        }
    }

    return nextState;
};
